export { default } from './DialogGetPhone';
export { default as DialogGetPhone } from './DialogGetPhone';
